import { html, nothing, TemplateResult } from "lit-html";
import { classMap } from "lit-html/directives/class-map";
import EmailTypeaheadComponent from '@components/typeahead/email';
import LawComplianceComponent from "@components/lawcompliance";
import ButtonField from '../buttonField';
import SocialButtonsTemplate from "./socialButtons";

const FormTemplate = async (config: ProposalConfigs, model: IProposalModel): Promise<TemplateResult> => {
  const {
    isEmptySearch,
    messages,
    captcha: {
      enabled: captchaEnabled
    },
    feature: {
      distanceFilterEnabled = false
    },
    subscription: {
      buttonAdditionalClass
    },
    socialLogin
  } = config;
  const {
    loading,
    handleSubmit,
    handleSocialSubmit,
    handleEmailChange,
    formData,
    formSubmitted
  } = model;
  const formClasses = {
    'no-distance-filter': !distanceFilterEnabled
  };

  const emailTypeaheadProps: IEmailTypeaheadProps = {
    placeholder: messages.JobSeekerSubscriptionDialogEmailLabel,
    labelText: messages.JobSeekerSubscriptionDialogEmailLabel,
    providersLimit: 5,
    onEmailChange: handleEmailChange
  }
  const submitButtonParams: ISubmitButton = {
    loading,
    additionalClass: buttonAdditionalClass,
    messages,
  }

  const formFieldClasses = {
    'proposal-form__field--error': formSubmitted && !formData.email?.isValid
  };

  const lawComplianceProps: ILawComplianceComponent = {
    messages,
    captchaEnabled
  }

  return html`
    <div class="modal-body">
      <p class="title">${messages.JobSeekerSubscriptionFavouriteTitle}</p>
      <div class="proposal-claim">
        ${!isEmptySearch ?
      html`<p
            class="description">
            ${messages.JobSeekerSubscriptionFavouriteText}</p>
          `
      : nothing}
      </div>
      <form class="proposal-form proposal-form-favourite ${classMap(formClasses)}" name="forms.proposal" novalidate @submit=${handleSubmit}>
        <div class="proposal-form__field ${classMap(formFieldClasses)}">
          <div class="proposal-form--error-message">
            <span>${messages.JobSeekerSubscriptionDialogInvalidEmailWarn}</span>
          </div>
          <div class="email-typeahead-container">
            ${EmailTypeaheadComponent(emailTypeaheadProps)}
          </div>
        </div>
        ${captchaEnabled ? html`<div id="modal-captcha-container"></div>` : nothing}
        ${ButtonField(submitButtonParams)}
      </form>
      ${LawComplianceComponent(lawComplianceProps)}
      ${socialLogin.enabled && socialLogin.insidePopupEnabled && handleSocialSubmit ? SocialButtonsTemplate({ messages, captchaEnabled, socialLogin, handleSocialSubmit }) : nothing}
    </div>`;
}

export default FormTemplate;